import type { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

// Type definitions for the DELETE /v2/users/me/avatar endpoint

type RemoveAvatarPath = paths['/v2/users/me/avatar']['delete'];

type RemoveAvatarResponse = RemoveAvatarPath['responses']['200']['content']['application/json'];

/**
 * removeAvatar
 *
 * Deletes the current user's avatar from S3 and updates their profile.
 * @returns The updated user record.
 */
export async function removeAvatar(): Promise<RemoveAvatarResponse['data']> {
  const { data } = await fetchClient.DELETE('/v2/users/me/avatar');

  if (!data) {
    throw new Error('No response data received');
  }

  return data.data;
}
